import React from "react"
//import I18n from "i18n-js/index.js.erb"

class ConnectedRoomsSelect extends React.Component{

  constructor(props) {
    super(props);
    this.updatePlaceholder = this.updatePlaceholder.bind(this)
  }

  componentDidMount(prevProps, prevState) {
    var self = this;

    this.initSelect2();

    // close menu when 'edit' is clicked
    $(document).on('click', '.option-action', function () {
      if (self.refs.connected_room) {
        $(self.refs.connected_room).select2("close");
      }
    });

    // refresh connected_rooms
    $(window).on('connected_roomChange', function (event, connected_room_id) {
      var connected_room_ids = $(self.refs.connected_room).select2('val');
      if (self.refs.connected_room) {
        $.ajax({
          type: 'GET',
          url: '/admin/get-connected_rooms',
          data: {
            connected_room_ids: connected_room_ids
          }
        }).done(function(data) {
          if (data && data.length) {
            self.props.onChange(data);
            var $select2Wrapper = $(self.refs.connected_room).siblings('.select2')
            for (var i = 0, ilen = data.length; i < ilen; i++) {
              var matchingOptions = $select2Wrapper.find('.option-data:contains("' + data[i].email + '")');
              if (matchingOptions.length > 0) {
                matchingOptions.html(self.processConnectedRoomName(data[i]));
              }
            }
          }
        });
      }
    });

   var intervalId = setInterval(this.updatePlaceholder, 100);
   // store intervalId in the state so it can be accessed later:
   this.setState({intervalId: intervalId});
  }

  componentWillUnmount() {
    // use intervalId from the state to clear the interval
    clearInterval(this.state.intervalId);
  }

  initSelect2() {
    var self = this;
    if (this.refs.connected_room) {
      $(this.refs.connected_room).select2({
        multiple: true,
        ajax: {
          url: '/admin/rooms_remote',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              room: self.props.room,
              page: params.page,
              results_per_page: 40,
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;

            return {
              results: data.items,
              pagination: {
                more: (params.page * 40) < data.total_count
              }
            };
          },
          cache: false
        },
        allowClear: false,
        escapeMarkup: function (markup) {
          return markup
        },
        placeholder: I18n.t('select_ellipsis'),
        templateResult: function (connected_room) {
          if (connected_room.loading) {
            return connected_room.text;
          }
          return self.processConnectedRoomName(connected_room);
        },
        templateSelection: function (connected_room) {
          if (connected_room && connected_room.id != null && connected_room.id != '' && self.props.room && self.props.room.id && connected_room.id === self.props.room.id  )  {
            self.props.onChange(connected_room)
          }
            return self.optionTemplate(connected_room)
        }
      }).on('change', function (e) {
        var select2_data = $(self.refs.connected_room).select2('data');
        self.props.onChange(select2_data)
      });
    }
  }

  updatePlaceholder() {
    $(this.refs.connected_rooms_select_wrapper).find('.select2-search__field').attr('placeholder', I18n.t('select_ellipsis'));
  }

  render() {
    var self = this;
    var options = this.props.connected_rooms && this.props.connected_rooms.length > 0 ? this.props.connected_rooms.map(function (connected_room) {
      return <option key={connected_room.id} value={connected_room.id}>{self.processConnectedRoomName(connected_room)}</option>
    }) : [];

    var values = this.props.connected_rooms && this.props.connected_rooms.length > 0 ? this.props.connected_rooms.map(function (connected_room) { return connected_room.id; }) : [];

    return (
      <div ref="connected_rooms_select_wrapper">
      <select defaultValue={values} multiple={true} className="form-control" ref="connected_room" style={{width: '100%', minHeight: 33}}>
        {options}
      </select>
      </div>
    );
  }

  optionTemplate(connected_room) {
    var connected_room_name = this.processConnectedRoomName(connected_room);
    return '<span><span class="option-data">' + connected_room_name + '</span></span>';
  }

  processConnectedRoomName(connected_room) {
    if(connected_room.connected_rooms && connected_room.connected_rooms.length) {
      var connected_rooms = connected_room.connected_rooms.map(function(connected_room) {
        return connected_room.identifier
      })
      var markup = connected_room.identifier + ' >> ' + `(${connected_rooms})`
      return markup
    } else {
      return connected_room.identifier || connected_room.text;
    }
  }

  shouldComponentUpdate() {
    return false;
  }

};

export default ConnectedRoomsSelect